import logger from './logger';

/**
 * Analytics Core - Camada Leve de Instrumentação de Produto
 * Desacopla as telas das ferramentas finas (Mixpanel, GA4, Datadog), 
 * permitindo o rastreio limpo de interações críticas sem ferir a LGPD.
 */
class Analytics {
  /**
   * Tracking Pragmático de Ação do Usuário
   * @param {string} category - A Entidade/Módulo (Ex: 'fichas', 'auth')
   * @param {string} action - O Verbo (Ex: 'generate_pdf', 'submit_fail')
   * @param {Object} metadata - Contexto não sensível (Ex: { duration_ms: 1200, error_code: 400 })
   */
  static trackEvent(category, action, metadata = {}) {
    // Sanitização de segurança de dados sensíveis (Senhas, Tokens) nunca devem passar por aqui
    const safePayload = { ...metadata };
    delete safePayload.password;
    delete safePayload.token;

    const eventData = {
      category,
      action,
      timestamp: new Date().toISOString(),
      url: window.location.pathname,
      ...safePayload
    };

    // Emulação local/console via Logger para validação em ambiente de QA.
    // Futura Integração: fetch('https://analytics.backend.../track', { method: 'POST', body: JSON.stringify(eventData) })
    logger.debug(`[Analytics Track]: ${category}:${action}`, eventData);
  }

  /**
   * Monitoramento de Fricção e Erros Críticos de Tela
   */
  static trackError(area, errorMessage, isFatal = false) {
    this.trackEvent('system_health', 'ui_error', { area, error_message: errorMessage, fatal: isFatal });
  }

  /**
   * Monitoramento Fino de Performance Percebida (Tempo até interatividade)
   */
  static trackPerformance(flowName, durationMs) {
    this.trackEvent('performance', 'latency_ms', { flow: flowName, duration_ms: durationMs });
  }
}

export default Analytics;
